export type AuthRole = 'client' | 'doctor' | 'clinic';

export const AUTH_DEFAULT_PATH: Record<AuthRole, string> = {
    client: '/profile/',
    doctor: '/profile-doctor/',
    clinic: '/profile-clinic/',
};

export function authTypeForPath(path: string): AuthRole {
    if (path.startsWith('/profile-doctor')) {
        return 'doctor';
    }
    if (path.startsWith('/profile-clinic')) {
        return 'clinic';
    }
    return 'client';
}

export function resolveAuthRedirectPath(
    role: AuthRole,
    redirect?: string | string[] | null,
): string {
    const defaultPath = AUTH_DEFAULT_PATH[role];
    const raw = Array.isArray(redirect) ? redirect[0] : redirect;

    if (!raw || !raw.startsWith('/') || raw.startsWith('//')) {
        return defaultPath;
    }

    if (role === 'doctor') {
        return raw.startsWith('/profile-doctor') ? raw : defaultPath;
    }

    if (role === 'clinic') {
        return raw.startsWith('/profile-clinic') ? raw : defaultPath;
    }

    if (raw.startsWith('/profile-doctor') || raw.startsWith('/profile-clinic')) {
        return defaultPath;
    }

    return raw.startsWith('/profile/') ? raw : defaultPath;
}
